import { useState, useEffect } from "react";
import request from "graphql-request";
import { baseUrl } from "services/shared/Environment";
import { categoriesQuery } from "./NavbarMenu.utils";
import { ApiCategory } from "data/api/ApiCategory";
import useFirebaseSession from "hooks/useFirebaseSession";
import { NavbarMenuState } from "./NavbarMenu.types";

export function useCategoriesQuery() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const data = await request(`${baseUrl()}/api/graphql`, categoriesQuery());
      setLoading(false);
      setData(data);
    };
    fetchData();
  }, []);

  const categories = data?.categories ?? [];

  return { loading, categories };
}

export function useNavbarMenuState(): NavbarMenuState {
  const { userIsLoggedIn } = useFirebaseSession();
  const { categories } = useCategoriesQuery();
  return { categories, userIsLoggedIn };
}
